import styled, { keyframes } from "styled-components";
import { ArrowScroll, Logo, TypedCarousel } from "../../../services/visualLibraryService";
import { i18n } from "../../../services/i18nService";
import { HeadingStyled } from "../../../styles/shared-styles";

const fadeIn = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

export const LayoutStyled = styled.section`
  padding-top: 1.021rem;
  width: 100%;
  top: 0;
  bottom: 0;
  position: absolute;
  will-change: transform;
  transform: ${props => `translateY(${props.position}px)`};
  transition: transform 0.2s linear;
  &::after {
    opacity: 0;
  }
  & .selected span{
    opacity:1 !important;
  }
  }
  .focused .selected svg{
    fill: ${props => props.theme.color.primary} !important;
  }

  & .jVddXe {
    ${props => (props.theme.locale.dir === i18n.directions.LEFT_TO_RIGHT ? `margin-left:0` : `margin-right:0`)};
  }

  & .slide.selected {
    opacity: 1 !important;
    transform: scaleY(1.05);
  }

  & .slide {
    //box-sizing:border-box;
    padding: 0;
  }

  & .selected [class*="PosterStyled"] {
    overflow:visible;
    transform: scale(1);
  }

  & [class*="PosterStyled"] {
    height:auto !important;
  }

  // & article.focused .selected [class*="ImageContainer"]::before {
  //   border-radius: 0.5rem;
  // }

  & [class*="EpgContainer"] [class*="BackgroundImageStyled"]:first-child {
    margin-top:0.5rem;
  }

  & [class*="ProgramItemsStyled"] {
    position:relative;
  }

  & [class*="ChannelImageContainer"] {
    position:absolute;
    ${props => (props.theme.locale.dir === i18n.directions.LEFT_TO_RIGHT ? `margin-left:0` : `margin-right:0`)};
    z-index: 999999;
  }

  & [class*="EpgContainer"] {
    position:relative;
  }

  & [class*="ProgramStyled"]{
    ${props =>
      props.theme.locale.dir === i18n.directions.LEFT_TO_RIGHT ? `margin-left:12.5rem` : `margin-right:12.5rem`};
    direction: ltr;
  }

  & [class*="EpgStyled"]{
    ${props =>
      props.theme.locale.dir === i18n.directions.LEFT_TO_RIGHT ? `margin-left:3.072rem` : `margin-right:3.072rem`};
  }

  & [class*="DateStyled"]{
    ${props =>
      props.theme.locale.dir === i18n.directions.LEFT_TO_RIGHT ? `margin-left:3.072rem` : `margin-right:3.072rem`};
  }

  & ul.timelineList {
    direction: ${props => (props.theme.locale.dir === i18n.directions.LEFT_TO_RIGHT ? `ltr` : `rtl`)};;
  }

  & [class*="TimeRulerStyled"]{
    position:absolute;
    direction: ltr;
  }

  & p[class*="TimeStyled"] {
    flex: 1 0 auto;
    padding-${props => (props.theme.locale.dir === i18n.directions.LEFT_TO_RIGHT ? `left` : `right`)}: 1rem;
    margin: auto;
    top: auto;
    width:auto;
    right: 0;
    position:relative;
    text-align: ${props => (props.theme.locale.dir === i18n.directions.LEFT_TO_RIGHT ? `right` : `left`)};
  }

  & [class*="ProgressStyled"] {
    flex: 1 1 100%;
    width: auto;
    margin: 0;
  }
  
  & [class*="PosterImageStyled"] {
    width: 32.5rem;
    height: 18.28125rem;
  }

  & [class*="HeadingStyled"] {
    font-weight: 900;
    font-size: 48px;
    ${props => (props.theme.locale.dir === i18n.directions.LEFT_TO_RIGHT ? `padding-left: 0` : `padding-right: 0`)};
  }

  & [class*="DetailStyled"] {
    margin-${props => (props.theme.locale.dir === i18n.directions.LEFT_TO_RIGHT ? "left" : "right")}: 0;
  }

  & .slider [class*="innerScrollContainer"] {
    overflow:visible !important;
    margin-top:1rem;
  }


  & .ReactVirtualized__Grid.ReactVirtualized__List, [class*="innerScrollContainer"] {
    overflow:visible !important;
  }

  & [class*="ArrowsContainer"] {
    margin-top:1.5rem;
  }

  & [class*="ButtonStyled"] {
    padding: 0.2em 0.3em;
  }

  & ul.programsList {
    direction: ${props => (props.theme.locale.dir === i18n.directions.LEFT_TO_RIGHT ? `ltr` : `rtl`)};
    margin-top: 0.2rem;

  }
  & ul.programsList li {
    position:relative;
    z-index: -1;
    margin-top: 0.2rem;
    overflow: hidden;
  }
  }
`;

export const FiltersStyled = styled.section`
 margin-${props => `${props.direction === "ltr" ? "left" : "right"}`}:6.5rem;
`;

export const ArrowScrollStyled = styled(ArrowScroll)`
  position: absolute;
  top: -${props => props.theme.spacing.large};
  left: 50%;
  transform: translateX(-50%);
  transition: all 0.2s linear;
  will-change: opacity;
  display: ${props => (props.isVisible ? "block" : "none")};
`;

export const StyledPage = styled.div`
  height: 19.9rem;
  ${props =>
    props.theme.locale.dir === i18n.directions.LEFT_TO_RIGHT ? `margin-left: 3.125rem` : `margin-right: 3.125rem`};
  & [class*="DetailContent"] {
    width: 40.26rem;
  }
  & h1 {
    font-size: 3.125rem !important;
    max-height: 10rem;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
  & [class*="DetailPoster"] {
    ${props => (props.theme.locale.dir === i18n.directions.LEFT_TO_RIGHT ? `margin-left: auto` : `margin-right: auto`)};
    float: right;
    ${props =>
      props.theme.locale.dir === i18n.directions.LEFT_TO_RIGHT ? `margin-right: 4.6875rem` : `margin-left: 4.6875rem`};
    width: 36.66rem;
  }
`;
export const ListWrapper = styled.div`
      //  margin-left: 5.5rem
      // margin-${props => `${props.direction === "ltr" ? "left" : "right"}`}:5.5rem;  
      ${props => `margin-${props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "right" : "left"}: 6.2rem`};
`;

export const FilterCarasoulStyled = styled(TypedCarousel)`
  transition: opacity 0.2s linear;
  will-change: opacity;
  /* TODO: Remove this when we change the carousel */
  .ReactVirtualized__Grid {
    will-change: initial !important;
  }
  &.focused {
  }

  .selected .gsYuAb::before {
    // border: ${props => (props.isFilterFocused ? `0.32rem solid #f1f1f1;` : `none`)} ;
  }
  & .Styled__ImageContainerStyled-t5q7es-1 {
    display: flex;
    justify-content: center;
    & img {
      width: ${props => (props.type === "channels" ? "auto" : "100%")};
      height: 100%;
    }
  }
`;

export const LayoutWrapperStyled = styled.div`
  position: relative;
  width: 93.958rem;
  ${props =>
    props.theme.locale.dir === i18n.directions.LEFT_TO_RIGHT ? `margin-left:1.8229rem` : `margin-right:1.8229rem`};
`;
